import Route from 'route-parser'
import { URL_SHORTENER } from 'constants/urls'
import observeRequest from 'helpers/fcObserveRequest'
import { map, Observable } from 'rxjs'

const route = new Route(URL_SHORTENER)

export function requestShorten (long: string): Observable<{ short: string, long: string }> {
  return observeRequest({
    url: route.reverse({}),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: long
  }).pipe(
    map((response: string) => JSON.parse(response))
  )
}

export function requestExpand (short: string): Observable<{ short: string, long: string }> {
  return observeRequest({
    url: route.reverse({ short }),
    headers: { 'Content-Type': 'application/json' }
  }).pipe(
    map((response: string) => JSON.parse(response))
  )
}
